import { PRODUCT_CREATE_FAILURE, PRODUCT_CREATE_REQUEST, PRODUCT_CREATE_SUCCESS, PRODUCT_LIST_FAILURE, PRODUCT_LIST_REQUEST, PRODUCT_LIST_SUCCESS } from 'checkout/constants';

const productReducer = (
  state = {
    isFetching: false,
    errorMessage: null,
    authenticated: false,
    response: [],
  },
  action,
) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        response: [],
        errorMessage: null,
      });
    case PRODUCT_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        response: action.response,
        authenticated: action.authenticated || false,
      });
    case PRODUCT_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.errorMessage,
      });
    case PRODUCT_CREATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        response: state.response,
        errorMessage: null,
      });
    case PRODUCT_CREATE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        response: state.response.concat([action.response]),
        authenticated: action.authenticated || false,
      });
    case PRODUCT_CREATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.errorMessage,
      });
    default:
      return state;
  }
};

export default productReducer;
